import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';


const firebaseConfig = {
  apiKey: "AIzaSyCsTcRqDOukSAXAyQKUKVXpodjasdNKC_U",
  authDomain: "webradio-b9c92.firebaseapp.com",
  projectId: "webradio-b9c92",
  storageBucket: "webradio-b9c92.firebasestorage.app",
  messagingSenderId: "650047509786",
  appId: "1:650047509786:web:44e7ce310aa30f4278c8a3"
};


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };